import {
    useFindOrganizationsMapStore,
    useMapRefStore,
    useMapStore,
} from "../store.jsx";
import propTypes from "prop-types";
import { MarkerF, OverlayView } from "@react-google-maps/api";
import NumberIndicator from "../../NumberIndicator";
import TFInfoBox from "./TFInfoBox.jsx";
export default function TFMarker({
    item,
    cluster,
    handleOrganizationIcons,
    group,
    hide,
}) {
    const {
        setSelectedItem,
        setCurrentPage,
        setMapPosition,
        setMarkerGroups,
        setLastPage,
        setShowCardPagination,
        showIndicators,
    } = useFindOrganizationsMapStore((state) => ({ ...state }));

    function findCommonGUIDs(master, ...arrays) {
        // Check if there are no arrays or any array is empty, return an empty array
        if (!arrays?.length || arrays.some((arr) => arr?.length === 0)) {
            return [];
        }

        // Use the first array as the base for comparison and filter its GUIDs
        return master.filter((guid) => {
            // Check if every other array includes the current GUID
            return arrays.every((array) => array.includes(guid));
        });
    }

    const getBranchList = () => {
        if (hide || group?.length < 2) return item.branches;

        const distinctBranches = group.reduce((acc, curr) => {
            const branches = curr.branches || [];
            branches.forEach((branch) => {
                if (!acc.includes(branch)) {
                    acc.push(branch);
                }
            });
            return acc;
        }, []);
        const commonBranches = findCommonGUIDs(
            distinctBranches,
            ...group.map((g) => g.branches),
        );
        return commonBranches.length === 1 ? commonBranches : [];
    };

    const {map} = useMapStore();
    const markerName =
        group?.length === 1 ? group[0].name : `${group.length} företag.`;
    const position = new window.google.maps.LatLng(
        item.geoLocation.latitude,
        item.geoLocation.longitude,
    );
    
    const handleClick = React.useCallback(() => {
            if (group.length > 1) {
                setMarkerGroups(group);
                setShowCardPagination(true);
                setCurrentPage(1);
                setLastPage(group.length);
            } else {
                setShowCardPagination(false);
                setCurrentPage(1);
                setLastPage(1);
                setMarkerGroups([]);
            }

            setSelectedItem(item);
            setMapPosition({
                lat: item?.geoLocation?.latitude,
                lng: item?.geoLocation?.longitude,
            });
        }, [group, item]);
    
    const handleIcon = React.useCallback(() => handleOrganizationIcons(getBranchList()), [group]);

    return (
        <MarkerF
            key={`marker-${markerName}`}
            position={position}
            clusterer={cluster}
            map={map}
            title={markerName}
            onClick={handleClick}
            icon={handleIcon()}
            visible={false}
            onLoad={(marker) => {
                marker.shouldBeHidden = hide;
            }}
        >
            {showIndicators && group.length > 1 && (
                <OverlayView
                    position={position}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                    <NumberIndicator
                        number={group.length}
                        visible={showIndicators}
                    />
                </OverlayView>
            )}
        </MarkerF>
    );
}

TFMarker.propTypes = {
    items: propTypes.arrayOf(propTypes.object),
    cluster: propTypes.object,
    handleOrganizationIcons: propTypes.func,
    group: propTypes.arrayOf(propTypes.object),
    item: propTypes.object,
};

export const TFMarkerMemo = React.memo(TFMarker);
